import { render, staticRenderFns } from "./search-not-found.vue?vue&type=template&id=6d66d1a9&lang=pug"
import script from "./search-not-found.vue?vue&type=script&lang=js"
export * from "./search-not-found.vue?vue&type=script&lang=js"
import style0 from "./search-not-found.vue?vue&type=style&index=0&id=6d66d1a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports